import React from "react";
import "./styles.scss";
import IframeShipmentTracker from "./IframeShipmentTracker";

function ShipmentTracker() {
  return (
    <div style={{ width: "100%", height: "100%", padding: "10px" }}>
      <IframeShipmentTracker />
    </div>
  );
}

export default ShipmentTracker;
